<div class="p-grid">
<div class="p-col-12">
    <app-filter
        [filterByInput]="cols"
        [filterByInputValue]="reportsData"
        (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)"
        (onClosePanel)="onClosePanel(selectedWindow)"
        (onApplyFilter)="onApplyFilter(selectedWindow, $event)"
        (onChangeRange)="onChangeRange(selectedWindow, $event)"
    ></app-filter>
</div>

<div class="p-col-12">
    <div class="card">
        <div class="main-content">
            <app-table
                [reportType]="'simpleTB'"
                [reportName]="reportName"
                [reportDate]="reportDate"
                [selectedWindow]="selectedWindow"
            ></app-table>
        </div>
    </div>
</div>
</div>
